import React from 'react';
import {Text, View} from 'react-native';
import styles from './styles';

interface Props {
  content: string | undefined;
  title: string | undefined;
}
export const Form = ({title, content}: Props) => {
  return (
    <View>
      <View>
        <Text style={[styles.bold, styles.title]}>{title && title}</Text>
      </View>
      <View>
        <Text style={[styles.content]}>{content && content}</Text>
      </View>
    </View>
  );
};
